import React, { Component } from 'react';
import {
    HashRouter as Router,
    Route
} from 'react-router-dom';
import BlockCard from '../components/additionalservices/blockcards.jsx';
import ICoupons from '../components/additionalservices/icoupons.jsx';
import CardDetails from '../components/adminuser/carddetails.jsx';
import CardNoDetails from '../components/adminuser/cardnodetails';
import CardSearch from '../components/adminuser/cardsearch.jsx';
import MobileNoDetails from '../components/adminuser/mobnodetails.jsx';
import UserIdDetails from '../components/adminuser/useriddetails.jsx';
import Application from '../components/application.jsx';
import NavFaqs from '../components/authpages/faqs.jsx';
import Privacy from '../components/authpages/privacy.jsx';
import Pds from '../components/authpages/pds.jsx';
import SecurityAwareness from '../components/authpages/security.jsx';
import CardActivity from '../components/cardsummary/activity.jsx';
import CardSummary from '../components/cardsummary/summary.jsx';
import AuthContactUs from '../components/contactus/authcontactus.jsx';
import DashBoard from '../components/dashboard/dashboard.jsx';
import CardInfo from '../components/dashboard/cardlist'
import Footer from '../components/footer/footer.jsx';
import ForceChangePassword from '../components/forcechangepassword/forcechangepassword.jsx';
import ForceChangesecretque from '../components/forcesecretPassword/forcesecretPassword.jsx';
import ForgotPassword from '../components/forgotpassword/forgotPassword.jsx';
// import TransferHistory from '../components/transferfunds/transferhistory.jsx'
import ForgotUserId from '../components/forgotuserId/forgotUserId.jsx';
import FriendsAndFamily from '../components/friends/friends.jsx';
import LoadCard from '../components/loadcard/loadcard.jsx';
import MobFAQS from '../components/mobilefaqs/mobfaq.jsx';
import MobTermAndCondition from '../components/mobileterms/mobiletermsncondition.jsx';
import MobPrivacyPolicy from '../components/mobprivacypolicy/mobprivacypolicy.jsx';
import MobSecurityAwareness from '../components/mobsecurityawareness/mobsecurityawareness.jsx';
import MyProfile from '../components/myprofile/myprofile.jsx';
import CardPreferance from '../components/navcardpreferences/navcardpreferences.jsx';
import ChangePassword from '../components/navchangepassword/navchangepassword.jsx';
import ChangePin from '../components/navchangepin/navchangepin.jsx';
import NavContact from '../components/navcontact/navcontact.jsx';
import Activate from '../components/register/navactivate.jsx';
import Signin from '../components/register/signin.jsx';
import Login from '../components/register/loginnew'
import ResetQuestion from '../components/resetsecretq/resetquestion.jsx';
import SessionOut from '../components/sessionout/sessionout.jsx';
import SubFooter from '../components/subfooter/subfooter.jsx';
import TermAndConditionPromoCard from '../components/termsandcondition/promocard-termsandcondition.jsx';
import TermAndCondition from '../components/termsandcondition/termsandcondition.jsx';
import termsandConditionMain from '../components/termsandcondition/termsandconditionmain.jsx';
import ShareFunds from '../components/transferfunds/sharefunds.jsx';
import TransferHistory from '../components/transferfunds/transferhistory.jsx';
import ViewTransferHistory from '../components/transferfunds/viewtransferhistory.jsx';
import UpgradeMyCard from '../components/upgrademygrade/upgrademycard.jsx';
import ActivateCard from '../components/register/register';
import LoadToCards from '../components/loadcard/loadtocards.jsx';
import ActivateAu from '../components/register/au.jsx';
import ActivateNz from '../components/register/nz.jsx';

import AppleWallet from '../components/wallet/applewallet.jsx';
import GoogleWallet from '../components/wallet/googlewallet.jsx';
import WalletFaq from '../components/wallet/walletfaq.jsx';
import WalletTerms from './../components/wallet/walletterms';
import TokenList from './../components/wallet/tokenlist';
import RequestCard from '../components/myprofile/requestcard.jsx';
import '../stylesheet/footer.css';
import termsandConditionProd from '../components/termsandcondition/termsandconditionprod.jsx';
import termsandConditionDigiWallet from '../components/termsandcondition/termsandconditiondigiwallet.jsx'

class Routes extends Component {    
    render() {
        return (
            <Router>
                <div>
                    <Route exact path="/" component={Application} />
                    <Route exact path="/cardsearch" component={CardSearch} />
                    <Route exact path="/carddetails" component={CardDetails} />
                    <Route exact path="/useriddetails" component={UserIdDetails} />
                    <Route exact path="/mobnodetails" component={MobileNoDetails} />
                    <Route exact path="/cardnodetails" component={CardNoDetails} />
                    <Route path="/registerCard" component={ActivateCard} />
                    <Route path="/login" component={Login} />
                    <Route path="/activate-card" component={Activate} />
                    <Route path="/nz" component={ActivateNz} />
                    <Route path="/au" component={ActivateAu} />
                    <Route path="/resetquestion" component={ResetQuestion} />
                    <Route path="/home" component={DashBoard} />
                    <Route path="/logout" component={Application} />
                    <Route path="/forgotuserid" component={ForgotUserId} />
                    <Route path="/forgotpassword" component={ForgotPassword} />
                    <Route path="/mobfaqs" component={MobFAQS} />
                    <Route path="/mobtermsandcondition" component={MobTermAndCondition} />
                    <Route path="/mobsecurityawareness" component={MobSecurityAwareness} />
                    <Route path="/mobprivacypolicy" component={MobPrivacyPolicy} />
                    <Route path="/fchangepassword" component={ForceChangePassword} />
                    <Route path="/ForceChangesecretque" component={ForceChangesecretque} />
                    
                    <Route path="/cardinfo" component={CardInfo} />
                    {/* <Route exact path="/my-cards" component={CardSummary} /> */}
                    <Route path="/card-summary" component={CardSummary} />
                    <Route path="/card-activity" component={CardActivity} />
                    <Route path="/signin" component={Signin} />
                    <Route path="/sessionout" component={SessionOut} />

                    {/* <Route exact path="/transfer-funds" component={TransferHistory} /> */}
                    <Route path="/friends&family" component={FriendsAndFamily} />
                    <Route path="/transfer-history" component={TransferHistory} />
                    <Route path="/share-funds" component={ShareFunds} />
                    <Route path="/viewtransfer_history" component={ViewTransferHistory} />

                    {/* <Route exact path="/additional-services" component={MyProfile} /> */}
                    <Route path="/i-coupons" component={ICoupons} />
                    <Route path="/block-card" component={BlockCard} />
                    <Route path="/manage-my-profile" component={MyProfile} />
                    <Route path="/change-password" component={ChangePassword} />
                    <Route path="/card-preferences" component={CardPreferance}/>

                    <Route path="/change-pin" component={ChangePin} />
                    <Route path="/my-profile/:id" component={MyProfile} />
                    <Route path="/upgrade-my-card" component={UpgradeMyCard} />
                    <Route path="/contact-us" component={NavContact} />
                    <Route path="/authcontact-us" component={AuthContactUs} />

                    <Route path="/faqs" component={NavFaqs} />
                    <Route path="/terms-&-conditionsgift" component={TermAndCondition} />
                    <Route path="/terms-&-conditionspromo" component={TermAndConditionPromoCard} />
                    <Route path="/terms-&-conditionsmain" component={termsandConditionMain} />
                    <Route path="/terms-&-conditiondigiwallet" component={termsandConditionDigiWallet} />
                    <Route exact path="/terms-&-conditionprod" component={termsandConditionProd} />
                    
                    <Route path="/privacy-policy" component={Privacy} />
                    <Route path="/pds" component={Pds} />
                    <Route path="/security-awareness" component={SecurityAwareness} />
                    {/* <Route path="/loadcard" component={LoadCard}/> */}
                    <Route path="/load-to-card" component={LoadToCards} />

                    <Route path="/googlewallet" component={GoogleWallet} />
                    <Route path="/applewallet" component={AppleWallet} />
                    <Route path="/walletfaq" component={WalletFaq} />
                    <Route path="/walletterms" component={WalletTerms} />
                    <Route path="/tokens" component={TokenList} />
                    <Route path="/requestcard" component={RequestCard} />

                     <SubFooter /> 
                    {/* <Footer /> */}

                </div>
            </Router >
        );
    }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/routes.jsx